import React from 'react'
import AddCandidate from '../add-candidate'
import CandidatePfd from '../candidate-pfd'

const CreateCandidateView = () => {
    return (
        <div>
            <div
                className={'container'}
                style={{
                    zIndex: 10,
                    minHeight: '100vh',
                    padding: '35px',
                }}
            >

                <AddCandidate />

            </div>
        </div>
    )
}

export default CreateCandidateView
